import { z } from 'zod';

import type { SelectIdentityRequest, SelectIdentityResponse } from './select-identity.dto.js';
import { UserAuthTokensResponseSchema } from './session.schema.js';

export const SelectIdentityRequestSchema: z.ZodType<SelectIdentityRequest> = z.object({}).strict();

export const SelectIdentityResponseSchema: z.ZodType<SelectIdentityResponse> =
  UserAuthTokensResponseSchema;
